module.exports = __webpack_public_path__ + "img/icon_map_2_5.ce63ce7f.png";